import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { toPng } from 'html-to-image';

import { Accordion, AccordionTab } from "primereact/accordion";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { useParams } from 'react-router-dom';
import { PMTemplate } from "../../../services/Template/pm-template";
import { Api } from "../../../services/api";
import { InputNumber } from "primereact/inputnumber";
import { FaCopy, } from 'react-icons/fa';
import { InputTextarea } from "primereact/inputtextarea";

import { InteriorDesignTemplate } from "../../../services/Template/interior-design-template";
import { BsFillInfoCircleFill } from "react-icons/bs";

const ConstructionAndInterior = ({ pmId }) => {

    const { editId } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [Section9Array, setSection9Array] = useState([{ name: '', }]);
    const [Section10Array, setSection10Array] = useState([{ name: '', }]);
    const [Section13Array, setSection13Array] = useState([{ name: '', }]);
    const [Section14Array, setSection14Array] = useState([{ name: '', }]);
    const [Section3Array, setSection3Array] = useState([{ name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', },]);

    const [isCopyBtnLoading, setIsCopyBtnLoading] = useState(false);

    const [inspectionsSection, setInspectionsSection] = useState([{ title: 'A' }]);

    const getTitleForInspectionsSection = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    const adjustTextareaHeight = (textarea) => {
        textarea.style.height = 'auto'; // Reset the height
        textarea.style.height = textarea.scrollHeight + 'px'; // Set the height to the scroll height
    };

    const expandAllTextareas = () => {
        elementRefs.forEach(ref => {
            if (ref.current) {
                const textareas = ref.current.querySelectorAll('textarea');
                textareas.forEach(adjustTextareaHeight);
            }
        });
    };

    //* -----------For Shedule Milestone---------------
    const [scheduleMilestonesSection, setScheduleMilestonesSection] = useState([{ title: 'A' }]);
    //! -----------For Shedule Milestone---------------

    const toast = useRef(null);

    const formik = useFormik({
        initialValues: PMTemplate.getFormName(),
        validate: (data) => {

        },

    });

    const formik2 = useFormik({
        initialValues: InteriorDesignTemplate.getFormName(),
        validate: (data) => {

        },

    });

    const formik3 = useFormik({
        initialValues: {
            pm_comment: '',
            in_comment: '',
            project_id: '',
            userId: '',
            combineDate: '',
        },
        validate: (data) => {

        },

        onSubmit: (data) => {
            if(!existPageWithoutSave){
                return;
        
            }

            data.userId = localStorage.getItem('user_id');
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
               'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            var url = Api.API_BASE_URL + 'interior-construction/save';

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    setExistPageWithoutSave(false);
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        setTimeout(function () {

                        }, 1000);


                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        },

    });

    const [existPageWithoutSave, setExistPageWithoutSave] = useState(false);

    useEffect(() => {
        if (editId) {
            getTemplateDetails(editId, 'pmId');
        }

        if (pmId) {
            getTemplateDetails(pmId, 'projectId');
        }

        getDetailsInterioDesign(pmId);

        getInteriorConstructionData(pmId);


        return () => {
            formik3.handleSubmit();
        };
    }, []);

    const [preConstructionShedule, setPreConstructionShedule] = useState([1]);

    const getTemplateDetails = (id, type) => {
        // fetch.
        var _body = {
            projectId: id,
        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        var url = Api.API_BASE_URL + 'construction/get';
        fetch(url, {
            method: "POST",
            headers:headers,

            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                // setIsLoading(false);

                if (response.error != '') {
                    formik.setFieldValue('PmTempleteId', 0);
                    
                    formik.setFieldValue('ProjectName', response.EstimatorProjectName);
          
                    // ----------suraj----------------
          
                    formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
                    formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
                    formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
                    formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_A_C_Date', response.scheduleProjectCompletion);
          
                    formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
                    formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_P_B_C_Date', response.ProjectCompletionDate);
                    formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_C_F_C_Date', response.ProjectCompletionDate);
                    // formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
                    // formik.setFieldValue('sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
                    // formik.setFieldValue('sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
                    // formik.setFieldValue('sitePrep_A_C_Date', response.scheduleProjectCompletion);
          
                    // formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
                    // formik.setFieldValue('turnOver_P_B_C_Date', response.ProjectCompletionDate);
                    // formik.setFieldValue('turnOver_C_F_C_Date', response.ProjectCompletionDate);
          
          
          
                  } else {
          
          
                    formik.setFieldValue('PmTempleteId', response.pmTemplateId);
                    PMTemplate.section_1_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_1[element]);
                    });
          
          
          
                    if (response.pm_section_2.length != 0) {
                      formik.setFieldValue(`inspectionsSection`, response.pm_section_2);
                      setInspectionsSection(response.pm_section_2);
                      // console.log('pm_section_2', formik.values.inspectionsSection);
          
          
                    }
          
                    // PMTemplate.section_2_List().forEach(element => {
                    //   formik.setFieldValue(element, response.pm_section_2[element]);
                    // });
                    // PMTemplate.section_3_List().forEach(element => {
                    //   formik.setFieldValue(element, response.pm_section_3[element]);
                    // });
                    PMTemplate.section_4_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_4[element]);
                    });
                    PMTemplate.section_5_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_5[element]);
                    });
                    if (response.pm_section_6.length != 0) {
                      formik.setFieldValue(`section_6`, response.pm_section_6);
                    }
                    if (response.pm_section_3_new.length != 0) {
                      formik.setFieldValue(`section_3`, response.pm_section_3_new);
                      setSection3Array(response.pm_section_3_new);
                    }
                    PMTemplate.section_7_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_7[element]);
                    });
          
                    formik3.setFieldValue('pm_date', response.pm_section_7.pm_date);
          
                    // PMTemplate.section_8_List().forEach(element => {
                    //   formik.setFieldValue(element, response.pm_section_8[element]);
                    // });
                    if (response.pm_section_8.length != 0) {
                      formik.setFieldValue(`scheduleMilestonesSectionList`, response.pm_section_8);
                      setScheduleMilestonesSection(response.pm_section_8);
                      // console.log('pm_section_2', formik.values.inspectionsSection);
          
          
                    }
          
          
                    formik.setFieldValue(`section_9`, response.pm_section_9);
                    setSection9Array(response.pm_section_9);
                    formik.setFieldValue(`section_10`, response.pm_section_10);
                    setSection10Array(response.pm_section_10);
                    PMTemplate.section_11_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_11[element]);
                    });
                    PMTemplate.section_12_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_12[element]);
                    });
          
          
          
                    formik.setFieldValue(`section_13`, response.pm_section_13);
                    setSection13Array(response.pm_section_13);
                    formik.setFieldValue(`section_14`, response.pm_section_14);
                    setSection14Array(response.pm_section_14);
                    PMTemplate.section_15_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_15[element]);
                    });
                    PMTemplate.section_16_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_16[element]);
                    });
                    PMTemplate.section_17_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_17[element]);
                    });
                    PMTemplate.section_18_List().forEach(element => {
                      formik.setFieldValue(element, response.pm_section_18[element]);
                    });
                    console.log('response.scheduleProjectCompletion', response.scheduleProjectCompletion);
          
                    if (response.pm_section_7.scheduleConstructionStartDate == '0000-00-00') {
          
                      console.log('response.scheduleProjectCompletion', response.scheduleProjectCompletion);
                      formik.setFieldValue('scheduleConstructionStartDate', response.scheduleProjectCompletion);
                      formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date', response.scheduleProjectCompletion);
                      formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_C_F_C_Date', response.scheduleProjectCompletion);
                      formik.setFieldValue('scheduleMilestonesSectionList.0.sitePrep_A_C_Date', response.scheduleProjectCompletion);
                    }
          
                    if (response.pm_section_7.scheduleProjectCompletion == '0000-00-00') {
                      formik.setFieldValue('scheduleProjectCompletion', response.ProjectCompletionDate);
                      formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_P_B_C_Date', response.ProjectCompletionDate);
                      formik.setFieldValue('scheduleMilestonesSectionList.0.turnOver_C_F_C_Date', response.ProjectCompletionDate);
                    }
          
          
          
          
          
          
          
                  }
                setIsLoading(false);

            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    const getDetailsInterioDesign = (id) => {
        // interior-template/get-interior/{editId}
       
        var _body = {
            projectId: id,
          }
        const token = localStorage.getItem('authToken');

    // Create headers with token if it exists
    const headers = {
       'Content-Type': 'application/json',
        'Authorization': token ? `Bearer ${token}` : ''
    };
        fetch(Api.API_BASE_URL + 'interior/get', {
            method: "POST",
            headers:headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                // setIsLoading(false);

                if (response.error != '') {
                    formik2.setFieldValue('project_id', response.project_id);
                    formik2.setFieldValue('interior_id', 0);
                } else {
                    formik2.setFieldValue('project_id', response.project_id);
                    formik2.setFieldValue('interior_id', response.interior_id);
                    InteriorDesignTemplate.section_1_List().forEach(element => {
                        formik2.setFieldValue(element, response.sec_1[element]);
                    });

                    InteriorDesignTemplate.section_2_List().forEach(element => {
                        formik2.setFieldValue(element, response.sec_2[element]);
                    }); InteriorDesignTemplate.section_3_List().forEach(element => {
                        formik2.setFieldValue(element, response.sec_3[element]);
                    });



                    if (response.sec_4.length != 0) {
                        formik2.setFieldValue(`section_4`, response.sec_4);
                    }
                    if (response.sec_5.length != 0) {
                        formik2.setFieldValue(`section_5`, response.sec_5);
                    }
                    if (response.sec_6.length != 0) {
                        formik2.setFieldValue(`section_6`, response.sec_6);
                    }
                    if (response.sec_7.length != 0) {
                        formik2.setFieldValue(`section_7`, response.sec_7);
                    }
                    if (response.sec_8.length != 0) {
                        formik2.setFieldValue(`section_8`, response.sec_8);
                    }



                    if (response.sec_9.length != 0) {
                        formik2.setFieldValue(`section_9`, response.sec_9);
                    }
                    if (response.sec_10.length != 0) {
                        formik2.setFieldValue(`section_10`, response.sec_10);
                        var t = [];
                        response.sec_10.forEach(element => {
                            t.push(0)
                        });
                        setPreConstructionShedule(t);
                    }

                    formik2.setFieldValue('project_id', response.project_id);
                    formik2.setFieldValue('interior_id', response.interior_id);

                }

                setIsLoading(false);

            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    const getInteriorConstructionData = (id) => {

        var _body = {
            project_id: id,
        }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
           'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        fetch(Api.API_BASE_URL + 'interior-construction/get', {
            method: "POST",
            headers:headers,
            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                // setIsLoading(false);
                if (response.error != '') {
                    formik3.setFieldValue('project_id', id);

                    formik3.setFieldValue('pm_comment', '');
                    formik3.setFieldValue('in_comment', '');

                } else {
                    formik3.setFieldValue('project_id', response.result.project_id);

                    formik3.setFieldValue('pm_comment', response.result.pm_comment);
                    formik3.setFieldValue('in_comment', response.result.in_comment);
                    formik3.setFieldValue('pm_date', response.result.pm_date);

                }

                setIsLoading(false);

            })
            .catch((error) => {
                console.error("Error:", error);
                setIsLoading(false);
            });
    }

    //* -----------------------
    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'
    };

    const borderStyle = {
    };

    const yesCellStyle = {
        ...cellStyle,
    };

    const firstColumnWidth = {
        width: "80px",
    };

    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };
    //! -----------------------

    //* ----------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, formData = '', maxLine = 2,) => (
        <textarea
            placeholder={placeholder}
            disabled
            name={fieldName}
            id={fieldName}
            rows={maxLine}
            value={formData != '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                console.log('e.target.value', fieldName);
                console.log('e.target.value', e.target.value);

                setExistPageWithoutSave(true);

                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        >{formData}</textarea>
    );

    const renderTextAreaFull = (fieldName, placeholder, formData = '', maxLine = 2,) => (
        <InputTextarea
            placeholder={placeholder}
            disabled
            name={fieldName}
            autoResize
            id={fieldName}
            rows={maxLine}
            value={formData !== '' ? formData : formik.values[fieldName]}
            onChange={(e) => {
                // console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></InputTextarea>
    );

    const renderTextAreaFullComments3 = (fieldName, placeholder, formData = '', maxLine = 2,) => (
        <InputTextarea
            placeholder={placeholder}
            name={fieldName}
            autoResize
            id={fieldName}
            rows={maxLine}
            value={formData !== '' ? formData : formik3.values[fieldName]}
            onChange={(e) => {
                // console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik3.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none',  color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', paddingLeft: '5px' }}
        ></InputTextarea>
    );

    const renderInputArea = (fieldName, placeholder, type = 'text', fromData = '') => {
        if(type=='date'){
            
            if(fromData != null){
                let timestamp = new Date(fromData);

                

                if (!isNaN(timestamp.getTime())) {
                    fromData= timestamp.toISOString().split('T')[0];
                 }
            }
        }

        let backgroundColor = '';
        if (fieldName === 'scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date') {
            backgroundColor = '#FFE1FF'; 
        } else if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_C_F_C_Date') {
            backgroundColor = '#FFCFB3'; 
        }else if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_P_B_C_Date') {
            backgroundColor = '#ffeb3b'; 
        }else if (fieldName === 'scheduleMilestonesSectionList.0.Completion_C_F_C_Date') {
            backgroundColor = '#96CEB4'; 
        }

        return (
        <input
            type={type}
            disabled
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={fromData != '' ? fromData : formik.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value);

                if (fieldName === 'scheduleMilestonesSectionList.0.sitePrep_P_B_C_Date') {
                    formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
                }
                if (fieldName === 'scheduleMilestonesSectionList.0.turnOver_C_F_C_Date') {
                    formik.setFieldValue('scheduleProjectCompletion', e.target.value);
                }
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                }
            }}
            style={{
                width: '100%',
                height: '40px',
                boxSizing: 'border-box',
                border: 'none',
                
                textAlign: 'center',
                marginTop: '0px',
                backgroundColor: backgroundColor
            }}
        />
    )};

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber
            inputId="currency-us"
            disabled
            value={formData != '' ? formData : formik.values[fieldName]}
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            placeholder="$0.00"
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.value)
            }}
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                
                textAlign: "center !important",
                marginTop: "0px",
                outline: 'none',
            }}
        />
    );
    //! ----------------------------------------------------------


    const renderSelect1 = (fieldName, formData = '') => {

        var val = (formData != '') ? formData : formik.values[fieldName];


        return <select
            name={fieldName}
            disabled
            id={fieldName}
            value={(formData != '') ? formData : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}>
            <option value="NO">No</option>
            <option value="YES">Yes</option>
        </select>
    };

    const section_8_Body = (title, fieldName_1, fieldName_2, fieldName_3, fieldName_4, fieldName_5, FormName_1, FormName_2, FormName_3, FormName_4, FormName_5) => {

        return (
            <tr>
                <td style={cellStyle}>{title}</td>
                <td style={cellStyleW}>{renderInputArea(fieldName_1, '', 'date', FormName_1)}</td>
                <td style={cellStyleW}>{renderInputArea(fieldName_2, '', 'date', FormName_2)}</td>
                <td style={cellStyleW}>{renderInputArea(fieldName_3, '', 'date', FormName_3)}</td>

                <td style={cellStyleW}>
                    {renderTextAreaFull(fieldName_4, '', FormName_4)}
                </td>

            </tr>
        );

    }

    const section_11_Body = (title, fieldName_1, fieldName_2) => {
        return (
            <tr>
                <td style={cellStyle}>{title}</td>
                <td style={{ ...cellStyle, textAlign: 'center', }}>{fieldName_1 == "jobRunningTotal" ? getJobRunningTotal() : fieldName_1 == "balance" ? getBalaceTotal() : renderInputAreaForAmount(fieldName_1)}</td>

            </tr>

        );
    }

    const getBalaceTotal = () => {

        var nettotal = Number(formik.values.contractPriceAmount) + Number(formik.values.approvedChangeOrderPrice) + Number(formik.values.allowanceDiffrence);
        var total = nettotal + Number(formik.values.gst) - Number(formik.values.amountPaid);

        var formattedTotal2 = total.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });
        //formik.setFieldValue('jobRunningTotal', total);
        return <div style={{ minHeight: '35px', paddingTop: '8px' }}><strong>{formattedTotal2}</strong></div>;
    }
    const getJobRunningTotal = () => {

        var total = Number(formik.values.contractPriceAmount) + Number(formik.values.approvedChangeOrderPrice) + Number(formik.values.allowanceDiffrence);

        var formattedTotal = total.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD'
        });

        //formik.setFieldValue('jobRunningTotal', total);
        return <div style={{ minHeight: '35px', paddingTop: '8px' }}><strong>{formattedTotal}</strong></div>;

    }

    //* -------------------------
    const copyImageToClipboard = (blob) => {
        // Check if Clipboard API is available
        if (navigator.clipboard && navigator.clipboard.write) {
            navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]).then(() => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
                console.log('Image copied to clipboard');
            }).catch((error) => {
                setIsCopyBtnLoading(false);
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
                console.error('Error copying image to clipboard:', error);
            });
        } else {
            setIsCopyBtnLoading(false);
            console.error('Clipboard API not available,', navigator.clipboard);
        }
    };

    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
        // Add more refs for additional elements as needed
    ];

    const updateHistory = () => {
        var user_id = localStorage.getItem('user_id');
        var role_id = localStorage.getItem('role_id');
        var _body = {
            user_id: user_id,
            role_id: role_id,
            project_id: pmId,
            type: 'Copy monthly Update',
            playbook_type: 'CONSTRUCTION & INTERIOR DESIGN'
        }
        fetch(Api.API_BASE_URL + 'playbook-history/save', {
            method: "POST",

            body: JSON.stringify(_body),
        })
            .then((response) => response.json())
            .then((response) => {
                // setIsLoading(false);
                // setProjectData(response.result);
            })
            .catch((error) => {
                // setIsLoading(false);
                console.error("Error:", error);
            });
    }

    const takeScreenshotAndCopy = async () => {
        setIsCopyBtnLoading(true);
        console.log('Take screenshot and copy to clipboard');

        updateHistory();

        try {
            // Expand all textareas to fit their content
            expandAllTextareas();

            const canvasPromises = elementRefs.map(async (ref) => {
                if (ref.current) {
                    return await toPng(ref.current, {
                        cacheBust: true,
                        pixelRatio: 2,
                    });
                }
                return null;
            });

            const images = await Promise.all(canvasPromises);

            // Create a new canvas to combine screenshots
            const combinedCanvas = document.createElement('canvas');
            const context = combinedCanvas.getContext('2d');

            // Calculate total height of combined screenshots
            let totalHeight = 0;
            let maxWidth = 0;
            for (const imgSrc of images) {
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        totalHeight += img.height;
                        if (img.width > maxWidth) maxWidth = img.width;
                        resolve();
                    };
                });
            }

            combinedCanvas.width = maxWidth;
            combinedCanvas.height = totalHeight;

            let offsetY = 0;
            for (const imgSrc of images) {
                const img = new Image();
                img.src = imgSrc;
                await new Promise((resolve) => {
                    img.onload = () => {
                        context.drawImage(img, 0, offsetY);
                        offsetY += img.height;
                        resolve();
                    };
                });
            }

            // Convert the combined canvas to a data URL
            combinedCanvas.toBlob(blob => {
                if (blob) {
                    copyImageToClipboard(blob);
                } else {
                    console.error('Error creating blob');
                }
            }, 'image/png');

        }
        catch (error) {
            setIsCopyBtnLoading(false);
            console.error('Error taking screenshots:', error);
        }
    };
    //! -------------------------

    //* ------interior-------------------
    const renderSelectInterior = (fieldName, formdata = '') => {
        var val = (formdata != '') ? formdata : formik2.values[fieldName];
        console.log('val', val);

        return <select
            name={fieldName}
            disabled
            id={fieldName}
            value={formdata !== '' ? formdata : formik2.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik2.setFieldValue(fieldName, e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center',  color: 'white', backgroundColor: '#ff0000', border: 'none' }}
        >
            <option value="N">No</option>
            <option value="Y">Yes</option>
            <option value="NA">N/A</option>
        </select>

    };

    const renderTextAreaFullInterior = (fieldName, placeholder, formData = '', maxLine = 2,) => (
        <InputTextarea
            placeholder={placeholder}
            disabled
            name={fieldName}
            autoResize
            id={fieldName}
            rows={maxLine}
            value={formData !== '' ? formData : formik2.values[fieldName]}
            onChange={(e) => {
                console.log(e.target.value)
                setExistPageWithoutSave(true);
                formik2.setFieldValue(fieldName, e.target.value)
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px', }}
        ></InputTextarea>
    );

    const renderInputAreaInterior = (fieldName, placeholder, type = 'text', formdata = '') => (
        <input
            type={type}
            disabled

            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formdata !== '' ? formdata : formik2.values[fieldName]}
            onChange={(e) => {
                setExistPageWithoutSave(true);
                formik2.setFieldValue(fieldName, e.target.value)
            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); 
                }
            }}
            style={{
                width: '100%',
                height: '40px',
                boxSizing: 'border-box',
                border: 'none',
                textAlign: 'center',
                marginTop: '0px',
            }}
        />
    );
    //! ------interior-------------------

    return (
        <>
            <Toast ref={toast} />
            {isLoading ? (
                <div className="loading-spinner">
                    Loading...
                    <div className="spinner"></div>
                </div>
            ) : (

                <form onSubmit={formik3.handleSubmit} className="pm-template-form">
                    <div className="flex justify-content-end submitbutton top-button" >
                        <Button className="m-2 mx-4 p-2 px-3 copySave-button" loading={isCopyBtnLoading} type="button" title="Copy Client monthly Update" onClick={takeScreenshotAndCopy}>

                            <strong className="mr-2">Copy monthly update</strong>
                            <FaCopy />
                        </Button>

                        <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center customSave-button" type="submit">
                            <strong className="mr-2">Save</strong>
                            <i className="pi pi-save"></i>
                        </Button>
                    </div>

                    <div className="cardd" style={{ border: 'none', }} >
                       
                        <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18]} >
                            {/* Section 1 */}
                            <AccordionTab header="MONTHLY PROJECT MANAGER UPDATE" className="mt-2" >
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Monthly Project Manager Update
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                                                    <div style={{ minWidth: '80%', display: 'flex', alignItems: 'center', }}>
                                                        <td style={{ width: '100px' }}>Dear:  </td>
                                                        {renderTextArea('dear', '???? ???', '')}
                                                    </div>
                                                    <input
                                                        type="date"
                                                        name="pm_date"
                                                        id="pm_date"
                                                        // value={formik3.values.pm_date}
                                                        value={ formik3.values.pm_date == null ? formik3.values.pm_date : !isNaN(new Date(formik3.values.pm_date).getTime()) ? new Date(formik3.values.pm_date).toISOString().split('T')[0] : formik3.values.pm_date}
                                                        onChange={(e) => { 
                                                            setExistPageWithoutSave(true)
                                                            formik3.setFieldValue('pm_date', e.target.value) }}
                                                        style={{ marginLeft: '10px', width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', textAlign: 'center' }}
                                                    />

                                                    <textarea
                                                        value={formik3.values.pm_date ? new Date(formik3.values.pm_date).toLocaleString('default', { month: 'long' }) : ''}
                                                        readOnly
                                                        style={{ marginLeft: '10px', width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', paddingTop: '12px', textAlign: 'center' }}
                                                    />
                                                </td>
                                            </tr>

                                          

                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                    Project Summary:
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                                    {renderTextAreaFull('projectSummary', '')}
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                   Schedules
                                                </td>
                                            </tr>

                                            <tr>
                                                <td style={{ ...borderStyle, display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                    </div>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                                                            Construction Start Date:
                                                            <sup> 
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From: Site Prep - Planned Baseline Completion Date '/>
                                                            </sup> 
                                                        </div>

                                                        <input
                                                            type="date"
                                                            disabled
                                                            name="scheduleConstructionStartDate"
                                                            id="scheduleConstructionStartDate"
                                                            
                                                            value={ formik.values.scheduleConstructionStartDate == null ? formik.values.scheduleConstructionStartDate : !isNaN(new Date(formik.values.scheduleConstructionStartDate).getTime()) ? new Date(formik.values.scheduleConstructionStartDate).toISOString().split('T')[0] : formik.values.scheduleConstructionStartDate}
                                                            onChange={(e) => {
                                                                setExistPageWithoutSave(true);
                                                                formik.setFieldValue('scheduleConstructionStartDate', e.target.value)
                                                            }}
                                                            readOnly
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', background: "#FFE1FF", textAlign: 'center' }}
                                                        />
                                                    </div>

                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ width: '25%', marginRight: '15px' }}>
                                                        </div>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>
                                                            Projected Completion:
                                                            <sup> 
                                                                <BsFillInfoCircleFill size={12} className='text-gray-500 hover:text-gray-900' title='This date is Comming From: Turn Over - Current Forecast Completion Date '/>
                                                            </sup> 
                                                        </div>

                                                        <input
                                                            type="date"
                                                            disabled
                                                            name="scheduleProjectCompletion"
                                                            id="scheduleProjectCompletion"
                                                            // value={formik.values['scheduleProjectCompletion']}
                                                            value={ formik.values.scheduleProjectCompletion == null ? formik.values.scheduleProjectCompletion : !isNaN(new Date(formik.values.scheduleProjectCompletion).getTime()) ? new Date(formik.values.scheduleProjectCompletion).toISOString().split('T')[0] : formik.values.scheduleProjectCompletion}
                                                            onChange={(e) => {
                                                                formik.setFieldValue('scheduleProjectCompletion', e.target.value)
                                                                setExistPageWithoutSave(true);
                                                            }}
                                                            readOnly
                                                            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', background: "#FFCFB3", textAlign: 'center' }}
                                                        />
                                                    </div>

                                                </td>

                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 2 */}

                            {scheduleMilestonesSection.map((item, index) => (
                                <AccordionTab header={
                                    <div className="flex justify-between items-center w-full accodianBtn" >

                                        <span className="font-bold white-space-nowrap ">SCHEDULE MILESTONES  {getTitleForInspectionsSection[index]}</span>


                                    </div>
                                } className="mt-2" >
                                    <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]} >
                                        <table style={{ borderCollapse: "collapse", }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ ...headerStyle, width: "400px" }}>
                                                        Schedule Milestones
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                        Planned Baseline Completion Date
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                        Current Forecast Completion Date
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                        Actual Completion Date
                                                    </th>
                                                    <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                        Notes:  If applicable, explain why there was a change fo the schedule
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {section_8_Body(`Site Prep`, `scheduleMilestonesSectionList.${index}.sitePrep_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_A_C_Date`, `scheduleMilestonesSectionList.${index}.sitePrep_Notes`, `scheduleMilestonesSectionList.${index}.sitePrep_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].sitePrep_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_A_C_Date, formik.values.scheduleMilestonesSectionList[index].sitePrep_Notes, formik.values.scheduleMilestonesSectionList[index].sitePrep_VP_C_Comments,)}

                                                {section_8_Body(`Demolition and Survey`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_A_C_Date`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_Notes`, `scheduleMilestonesSectionList.${index}.demolitionAndSurvey_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_A_C_Date, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_Notes, formik.values.scheduleMilestonesSectionList[index].demolitionAndSurvey_VP_C_Comments,)}

                                                {section_8_Body(`Footings and Foundation`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_A_C_Date`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_Notes`, `scheduleMilestonesSectionList.${index}.footingAndFoundation_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_A_C_Date, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_Notes, formik.values.scheduleMilestonesSectionList[index].footingAndFoundation_VP_C_Comments,)}

                                                {section_8_Body(`Framing`, `scheduleMilestonesSectionList.${index}.framing_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.framing_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.framing_A_C_Date`, `scheduleMilestonesSectionList.${index}.framing_Notes`, `scheduleMilestonesSectionList.${index}.framing_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].framing_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_A_C_Date, formik.values.scheduleMilestonesSectionList[index].framing_Notes, formik.values.scheduleMilestonesSectionList[index].framing_VP_C_Comments,)}

                                                {section_8_Body(`Roofing and Mechanical`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_A_C_Date`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_Notes`, `scheduleMilestonesSectionList.${index}.roofingAndMechanical_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_A_C_Date, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_Notes, formik.values.scheduleMilestonesSectionList[index].roofingAndMechanical_VP_C_Comments,)}

                                                {section_8_Body(`Exterior Finish`, `scheduleMilestonesSectionList.${index}.exteriorFinish_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_A_C_Date`, `scheduleMilestonesSectionList.${index}.exteriorFinish_Notes`, `scheduleMilestonesSectionList.${index}.exteriorFinish_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_A_C_Date, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_Notes, formik.values.scheduleMilestonesSectionList[index].exteriorFinish_VP_C_Comments,)}

                                                {section_8_Body(`Insulation and Drywall`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_A_C_Date`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_Notes`, `scheduleMilestonesSectionList.${index}.insulationAndDrywall_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_A_C_Date, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_Notes, formik.values.scheduleMilestonesSectionList[index].insulationAndDrywall_VP_C_Comments,)}

                                                {section_8_Body(`Completion`, `scheduleMilestonesSectionList.${index}.Completion_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_A_C_Date`, `scheduleMilestonesSectionList.${index}.Completion_Notes`, `scheduleMilestonesSectionList.${index}.Completion_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].Completion_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_A_C_Date, formik.values.scheduleMilestonesSectionList[index].Completion_Notes, formik.values.scheduleMilestonesSectionList[index].Completion_VP_C_Comments,)}

                                                {section_8_Body(`Turn Over`, `scheduleMilestonesSectionList.${index}.turnOver_P_B_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_C_F_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_A_C_Date`, `scheduleMilestonesSectionList.${index}.turnOver_Notes`, `scheduleMilestonesSectionList.${index}.turnOver_VP_C_Comments`, formik.values.scheduleMilestonesSectionList[index].turnOver_P_B_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_C_F_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_A_C_Date, formik.values.scheduleMilestonesSectionList[index].turnOver_Notes, formik.values.scheduleMilestonesSectionList[index].turnOver_VP_C_Comments,)}

                                            </tbody>
                                        </table>
                                    </div>
                                </AccordionTab>
                            ))}

                            {/* Section 3*/}
                            <AccordionTab header="IVITIES WORKED ON THIS WEEK" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]} >
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>
                                                    Activities worked on this week: (Description)
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Contractor
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Brief Scope of Work
                                                </th>
                                                <th style={{ ...headerStyle, width: "250px" }}>
                                                    Current Forecasted Completion Date
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {Section9Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_9.${index}.activitiesworkedOnThisWeek`, '', formik.values.section_9[index].activitiesworkedOnThisWeek)}</td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_9.${index}.Constractor`, '', '', formik.values.section_9[index].Constractor)}</td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_9.${index}.briefScopeOfWeek`, '', formik.values.section_9[index].briefScopeOfWeek)}
                                                    </td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_9.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_9[index].CurrentForecastedCompletionDate)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 14 */}
                            <AccordionTab header="ACTIVITIES SCHEDULED FOR NEXT WEEK" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>
                                                    Activities Scheduled for Next Week: (Description)
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Contractor
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Brief Scope of Work
                                                </th>
                                                <th style={{ ...headerStyle, width: "250px" }}>
                                                    Current Forecasted Completion Date
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Section10Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_10.${index}.activitiesScheduledOnNextWeek`, '', formik.values.section_10[index].activitiesScheduledOnNextWeek)}</td>
                                                    
                                                    <td style={cellStyleW}>{renderInputArea(`section_10.${index}.Constractor`, '', '', formik.values.section_10[index].Constractor)}</td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_10.${index}.briefScopeOfWeek`, '', formik.values.section_10[index].briefScopeOfWeek)}
                                                    </td>
                                                    <td style={cellStyleW}>{renderInputArea(`section_10.${index}.CurrentForecastedCompletionDate`, '', 'date', formik.values.section_10[index].CurrentForecastedCompletionDate)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 5 */}
                            <AccordionTab header="PROJECT BUDGET" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[4]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>
                                                    Project Budget
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Amount
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {section_11_Body('Contract Price', 'contractPriceAmount', 'contractPriceVPCComment')}
                                            {section_11_Body('Approved Change Order Price', 'approvedChangeOrderPrice', 'approvedChangeOrderVPCComment')}
                                            {section_11_Body('Allowance Difference (Selections to Date)', 'allowanceDiffrence', 'allowanceDiffrenceVPCComment')}
                                            {section_11_Body('Job Running Total', 'jobRunningTotal', 'jobRunningTotalVPCComment')}
                                            {section_11_Body('GST', 'gst', 'gstVPCComment')}
                                            {section_11_Body('Amount Paid ', 'amountPaid', 'amountPaidVPCComment')}
                                            {section_11_Body('Balance (Not Including Deposit)', 'balance', 'balanceVPCComment')}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 6 */}
                            <AccordionTab header="PROJECT DEPOSITS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[5]}>
                                    <table style={{ borderCollapse: "collapse" }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>
                                                    Project Deposits
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Amount
                                                </th>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {section_11_Body('Contract Deposits', 'contractDepositsAmount', 'contractDepositsVPCComments')}
                                            {section_11_Body('Building Permit Deposit', 'buildingPermitDepositAmount', 'buildingPermitDepositVPCComments')}
                                            {section_11_Body('Other Deposits', 'otherDepositAmount', 'otherDepositVPCComments')}
                                            {section_11_Body('Total Deposits', 'totalDepositAmount', 'totalDepositVPCComments')}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 7 */}
                            <AccordionTab header="CHANGE WORK ORDERS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[6]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "400px" }}>
                                                    Change Work Orders (# and Description)
                                                </th>
                                                <th style={{ ...headerStyle, width: "200px" }}>
                                                    Date
                                                </th>
                                                <th style={{ ...headerStyle, width: "200px" }}>
                                                    Amount
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }}>
                                                    Approved
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Notes
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Section13Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_13.${index}.changeWorkOrder`, '', formik.values.section_13[index].changeWorkOrder)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputArea(`section_13.${index}.date`, '', 'date', formik.values.section_13[index].date)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderInputAreaForAmount(`section_13.${index}.amount`, formik.values.section_13[index].amount)}
                                                    </td>
                                                    <td style={{ ...dropdownCellStyle, minWidth: '85px', height: '32px', }}>
                                                        {renderSelect1(`section_13.${index}.approved`, formik.values.section_13[index].approved)}
                                                    </td>
                                                    <td style={cellStyleW}>
                                                        {renderTextAreaFull(`section_13.${index}.notes`, '', formik.values.section_13[index].notes)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            {/* Section 8 */}
                            <AccordionTab header="ACTION ITEMS DISCUSSED" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[7]} >
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "auto" }}>
                                                    Action Items Discussed
                                                </th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Section14Array.map((item, index) => (
                                                <tr>
                                                    <td style={cellStyleW}>{renderTextAreaFull(`section_14.${index}.actionItemDiscussed`, '', formik.values.section_14[index].actionItemDiscussed)}</td>
                                                </tr>
                                            ))}

                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                            <AccordionTab header="CONSTRUCTION COMMENTS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[8]} >
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                    Construction Comments
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFullComments3('pm_comment', '', formik3.values.pm_comment, 6)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>


                            <AccordionTab header=" MONTHLY INTERIOR DESIGN UPDATE" className="mt-2">

                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[9]}>

                                    <table style={{ borderCollapse: "collapse" }}>

                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto", }} >
                                                    Monthly Interior Design Update
                                                </th>

                                            </tr>

                                        </thead>

                                        <tbody>
                                            <tr>
                                                <td style={{ minWidth: '50vw', display: 'flex', alignItems: 'center', paddingTop: '15px' }}>
                                                    <td style={{ width: '100px' }}>Dear:  </td>
                                                    {renderTextArea('dear', '',)}

                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ textAlign: 'center', verticalAlign: 'middle', paddingTop: '15px', paddingBottom: '10px', fontWeight: 'bold' }}>
                                                    Here Is Your Monthly Summary:
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                    </div>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>From</div>
                                                        <input
                                                            type="date"
                                                            disabled
                                                            name="summaryFrom"
                                                            id="summaryFrom"
                                                            // value={formik.values['summaryFrom']}
                                                            value={ formik2.values.summaryFrom == null ? formik2.values.summaryFrom : !isNaN(new Date(formik2.values.summaryFrom).getTime()) ? new Date(formik2.values.summaryFrom).toISOString().split('T')[0] : formik2.values.summaryFrom}
                                                            onChange={(e) => formik.setFieldValue('summaryFrom', e.target.value)}
                                                            style={{ width: '100%', textAlign: 'center',  height: '32px', color: '#495057', }}

                                                        />
                                                    </div>
                                                    <div style={{ width: '25%', marginRight: '15px' }}>
                                                        <div style={{ textAlign: 'center', marginBottom: '5px' }}>To:</div>
                                                        <input
                                                            type="date"
                                                            disabled
                                                            name="summaryTo"
                                                            id="summaryTo"
                                                            value={ formik2.values.summaryTo == null ? formik2.values.summaryTo : !isNaN(new Date(formik2.values.summaryTo).getTime()) ? new Date(formik2.values.summaryTo).toISOString().split('T')[0] : formik2.values.summaryTo}
                                                            onChange={(e) => formik2.setFieldValue('summaryTo', e.target.value)}
                                                            style={{ width: '100%', textAlign: 'center',  height: '32px', color: '#495057', }}
                                                        />
                                                    </div>

                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>


                                    <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, width: "300px", }} >
                                                    Id Documents
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    Area
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                   Selections
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }} >
                                                    Completed Yes/No/NA
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    Interior Designer Comments
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }} >
                                                    Id Bid Req
                                                </th>
                                                <th style={{ ...headerStyle, width: "100px" }} >
                                                    PO
                                                </th>
                                                <th style={{ ...headerStyle, minWidth: "auto" }} >
                                                    PO or Drawing Due Date
                                                </th>



                                            </tr>
                                        </thead>

                                        <tbody>

                                            {InteriorDesignTemplate.getFormName().section_4.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>
                                                        <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={4}> Pre Start</td>
                                                        <td style={{ ...cellStyle }} rowSpan={4} >  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_4.${index}.completed`, formik2.values.section_4[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_4.${index}.interiorDesignerComments`, ' ', formik2.values.section_4[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, minWidth: '100px', height: '32px', }}>  {renderSelectInterior(`section_4.${index}.idBidReq`, formik2.values.section_4[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_4.${index}.pO`, formik2.values.section_4[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_4.${index}.poOrDDue`, '', 'date', formik2.values.section_4[index].poOrDDue)} </td>
                                                    </tr>
                                                    ) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_4.${index}.completed`, formik2.values.section_4[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_4.${index}.interiorDesignerComments`, '', formik2.values.section_4[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_4.${index}.idBidReq`, formik2.values.section_4[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_4.${index}.pO`, formik2.values.section_4[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_4.${index}.poOrDDue`, '', 'date', formik2.values.section_4[index].poOrDDue)} </td>

                                                        </tr>
                                                    )
                                                )
                                            })

                                            }


                                            {/* SCHEDULES  EXTERIOR  Start */}
                                            {InteriorDesignTemplate.getFormName().section_5.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>
                                                        <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={14}> Schedules</td>
                                                        <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_5.${index}.completed`, formik2.values.section_5[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_5.${index}.interiorDesignerComments`, '', formik2.values.section_5[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_5.${index}.idBidReq`, formik2.values.section_5[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_5.${index}.pO`, formik2.values.section_5[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_5.${index}.poOrDDue`, '', 'date', formik2.values.section_5[index].poOrDDue)} </td>


                                                    </tr>) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_5.${index}.completed`, formik2.values.section_5[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_5.${index}.interiorDesignerComments`, '', formik2.values.section_5[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_5.${index}.idBidReq`, formik2.values.section_5[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_5.${index}.pO`, formik2.values.section_5[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_5.${index}.poOrDDue`, '', 'date', formik2.values.section_5[index].poOrDDue)} </td>


                                                        </tr>
                                                    )
                                                )
                                            })

                                            }

                                            {/* SCHEDULES  EXTERIOR  End */}
                                            {/* SCHEDULES  INTERIOR  start */}
                                            {InteriorDesignTemplate.getFormName().section_6.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>

                                                        <td style={{ ...cellStyle }} rowSpan={11} > INTERIOR  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_6.${index}.completed`, formik2.values.section_6[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_6.${index}.interiorDesignerComments`, '', formik2.values.section_6[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_6.${index}.idBidReq`, formik2.values.section_6[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_6.${index}.pO`, formik2.values.section_6[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_6.${index}.poOrDDue`, '', 'date', formik2.values.section_6[index].poOrDDue)} </td>

                                                    </tr>) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_6.${index}.completed`, formik2.values.section_6[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_6.${index}.interiorDesignerComments`, '', formik2.values.section_6[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_6.${index}.idBidReq`, formik2.values.section_6[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_6.${index}.pO`, formik2.values.section_6[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_6.${index}.poOrDDue`, '', 'date', formik2.values.section_6[index].poOrDDue)} </td>

                                                        </tr>
                                                    )
                                                )
                                            })

                                            }
                                            {/* SCHEDULES  INTERIOR  End */}


                                            {/* DRAWINGS  EXTERIOR  Start */}
                                            {InteriorDesignTemplate.getFormName().section_7.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>
                                                        <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={15}> Drawings</td>
                                                        <td style={{ ...cellStyle }} rowSpan={3} > EXTERIOR  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_7.${index}.completed`, formik2.values.section_7[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_7.${index}.interiorDesignerComments`, ' ', formik2.values.section_7[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_7.${index}.idBidReq`, formik2.values.section_7[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_7.${index}.pO`, formik2.values.section_7[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_7.${index}.poOrDDue`, '', 'date', formik2.values.section_7[index].poOrDDue)} </td>

                                                    </tr>) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_7.${index}.completed`, formik2.values.section_7[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_7.${index}.interiorDesignerComments`, ' ', formik2.values.section_7[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_7.${index}.idBidReq`, formik2.values.section_7[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_7.${index}.pO`, formik2.values.section_7[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_7.${index}.poOrDDue`, '', 'date', formik2.values.section_7[index].poOrDDue)} </td>

                                                        </tr>
                                                    )
                                                )
                                            })

                                            }

                                            {/* DRAWINGS  EXTERIOR  End */}

                                            {/* DRAWINGS  INTERIOR  start */}
                                            {InteriorDesignTemplate.getFormName().section_8.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>

                                                        <td style={{ ...cellStyle }} rowSpan={12} > INTERIOR  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_8.${index}.completed`, formik2.values.section_8[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_8.${index}.interiorDesignerComments`, ' ', formik2.values.section_8[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_8.${index}.idBidReq`, formik2.values.section_8[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_8.${index}.pO`, formik2.values.section_8[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_8.${index}.poOrDDue`, '', 'date', formik2.values.section_8[index].poOrDDue)} </td>

                                                    </tr>) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_8.${index}.completed`, formik2.values.section_8[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_8.${index}.interiorDesignerComments`, ' ', formik2.values.section_8[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_8.${index}.idBidReq`, formik2.values.section_8[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_8.${index}.pO`, formik2.values.section_8[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_8.${index}.poOrDDue`, '', 'date', formik2.values.section_8[index].poOrDDue)} </td>

                                                        </tr>
                                                    )
                                                )
                                            })

                                            }
                                            {/* DRAWINGS  INTERIOR  End */}

                                            {InteriorDesignTemplate.getFormName().section_9.map((item, index) => {
                                                return (
                                                    index == 0 ? (<tr>
                                                        <td style={{ ...cellStyle, textAlign: 'center', fontWeight: '600' }} rowSpan={6}> Site Inspections Complete</td>
                                                        <td style={{ ...cellStyle }} rowSpan={6} >  </td>
                                                        <td style={{ ...cellStyle }} > {item.selection} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_9.${index}.completed`, formik2.values.section_9[index].completed)} </td>
                                                        <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_9.${index}.interiorDesignerComments`, ' ', formik2.values.section_9[index].interiorDesignerComments)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_9.${index}.idBidReq`, formik2.values.section_9[index].idBidReq)} </td>
                                                        <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_9.${index}.pO`, formik2.values.section_9[index].pO)} </td>
                                                        <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_9.${index}.poOrDDue`, '', 'date', formik2.values.section_9[index].poOrDDue)} </td>

                                                    </tr>) : (
                                                        <tr>

                                                            <td style={{ ...cellStyle }} > {item.selection} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_9.${index}.completed`, formik2.values.section_9[index].completed)} </td>
                                                            <td style={{ ...cellStyleW, }}>  {renderTextAreaFullInterior(`section_9.${index}.interiorDesignerComments`, ' ', formik2.values.section_9[index].interiorDesignerComments)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}>  {renderSelectInterior(`section_9.${index}.idBidReq`, formik2.values.section_9[index].idBidReq)} </td>
                                                            <td style={{ ...dropdownCellStyle, width: "100px", height: '32px', }}> {renderSelectInterior(`section_9.${index}.pO`, formik2.values.section_9[index].pO)} </td>
                                                            <td style={{ ...cellStyleW, }}> {renderInputAreaInterior(`section_9.${index}.poOrDDue`, '', 'date', formik2.values.section_9[index].poOrDDue)} </td>

                                                        </tr>
                                                    )
                                                )
                                            })

                                            }
                                            <tr>
                                                <td>Risk/Safety/Client/Team/Other?</td>
                                                <td style={{ ...cellStyleW, }} colSpan={8}>  {renderTextAreaFullInterior('riskSafety', '')} </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                            </AccordionTab>

                            <AccordionTab header="INTERIOR COMMENTS" className="mt-2">
                                <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[10]}>
                                    <table style={{ borderCollapse: "collapse", }}>
                                        <thead>
                                            <tr>
                                                <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Interior  Comments
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={cellStyleW}>
                                                    {renderTextAreaFullComments3('in_comment', '', formik3.values.in_comment, 6)}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </AccordionTab>

                        </Accordion>
                    </div>
                </form >

            )}

        </>
    );
};

export default ConstructionAndInterior;
